<template>
    <a href="javascript:void(0)" class="box_col-1 cart btn-orange-white" :class="{ 'active' : isOpen }" @click="open">
        <span class="count"> {{ total }} </span> <i class="icon-cart"></i>
    </a>
</template>

<script>
    export default {
        name: 'BasketButton',
        computed: {
            isOpen() {
                return this.$store.state.isBasketOpen
            },
            total() {
                return this.$store.getters.basketTotalCount || '0'
            }
        },
        methods: {
            open () {
                this.$store.state.isBasketOpen=!this.$store.state.isBasketOpen
                this.$store.state.isMenuOpen=false
                this.$store.state.isLoginFormOpen=false
            },
            close () {
                this.$store.state.isBasketOpen=false
                this.$store.state.isMenuOpen=false
                this.$store.state.isLoginFormOpen=false
            }
        },
        created() {
            this.close()
        }
    }
</script>